import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Accordion } from 'react-bootstrap';
import { useAppDispatch } from '@application/store/useStore';
import { getAllEmployeeHourTypeAsync, getEmployeeHourTypeByIdAsync } from '@application/features/employeehourtype/employeehourtypeThunk';
import { TimeKeepingTable } from './TimeKeepingTable';
import ModalPopup from '@ui/components/VnModal';
import { AddTimeKeepingForm } from './AddTimeKeepingForm';
import { WorkorderCategoriesTable } from './WorkorderCategoriesTable';
import { getAllJobCategoriesAsync, getJobCategoryByIdAsync } from '@application/features/jobcategory/jobcategoryThunk';
import { AddWorkorderCategoriesForm } from './AddWorkorderCategoriesForm';
import { getAllWorkTypeAsync } from '@application/features/workType/workTypeThunk';
import { WorkTypeTable } from './WorkTypeTable';
import { UpdateWorkTypeForm } from './UpdateWorkTypeForm';
import TimeChimpSync from './TimeChimpSync';
const AppSettingsTab = () => {
    const dispatch = useAppDispatch();
    //  const [isAppSettingFormOpen, setAppSettingFormOpen] = useState<boolean>(false);
    const [isUpdateAppSettingFormOpen, setUpdateAppSettingFormOpen] = useState(false);
    const [isAddWorkCategoryFormOpen, setAddWorkCategoryFormOpen] = useState(false);
    const [isUpdateWorkCategoryFormOpen, setUpdateWorkCategoryFormOpen] = useState(false);
    const [isUpdateWorkTypeFormOpen, setUpdateWorkTypeFormOpen] = useState(false);
    const [currentWorkTypeId, setCurrentWorkTypeId] = useState(null);
    //------------TimeKeeping-----------------
    const onTimeKeepingcloseClicked = () => {
        //setAppSettingFormOpen(false);
        setUpdateAppSettingFormOpen(false);
    };
    // const onAddTimeKeepingClick = () => {
    //     setAppSettingFormOpen(true);
    // };
    const handleTimeKeepingTableRowClick = (id) => {
        dispatch(getEmployeeHourTypeByIdAsync(id));
        setUpdateAppSettingFormOpen(true);
    };
    //----------WorkCategory-----------------
    const onAddCategoryClick = () => {
        setAddWorkCategoryFormOpen(true);
    };
    const onWorkorderCategorycloseClicked = () => {
        setAddWorkCategoryFormOpen(false);
        setUpdateWorkCategoryFormOpen(false);
    };
    const handleWorkorderCategoryTableRowClick = (id) => {
        dispatch(getJobCategoryByIdAsync(id));
        setUpdateWorkCategoryFormOpen(true);
    };
    //---------------WorkType-----------------
    const handleWorkTypeTableRowClick = (id) => {
        setUpdateWorkTypeFormOpen(true);
        setCurrentWorkTypeId(id);
    };
    const onWorkTypeCloseClicked = () => {
        setUpdateWorkTypeFormOpen(false);
    };
    //----------Common-------------
    useEffect(() => {
        dispatch(getAllEmployeeHourTypeAsync());
        dispatch(getAllJobCategoriesAsync());
        dispatch(getAllWorkTypeAsync());
    }, []);
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: 'mt-4', children: _jsxs(Accordion, { children: [_jsxs(Accordion.Item, { eventKey: '0', className: 'vn-appsetting-accordian-item', children: [_jsx(Accordion.Header, { style: { color: '#006d9e' }, children: "Werkorder Categorieen" }), _jsxs(Accordion.Body, { children: [_jsx("div", { style: {
                                                display: 'flex',
                                                justifyContent: 'end',
                                                alignItems: 'center',
                                                marginRight: 'auto',
                                                marginLeft: '0rem',
                                                marginTop: '1rem',
                                                marginBottom: '1rem'
                                            } }), _jsx(WorkorderCategoriesTable, { onHandleRowClick: handleWorkorderCategoryTableRowClick })] })] }), _jsxs(Accordion.Item, { eventKey: '1', className: 'vn-appsetting-accordian-item', children: [_jsx(Accordion.Header, { children: "Tijdwaarneming" }), _jsxs(Accordion.Body, { children: [_jsx("div", { style: {
                                                display: 'flex',
                                                justifyContent: 'end',
                                                alignItems: 'center',
                                                marginRight: 'auto',
                                                marginLeft: '0rem',
                                                marginTop: '1rem',
                                                marginBottom: '1rem'
                                            } }), _jsx(TimeKeepingTable, { onHandleRowClick: handleTimeKeepingTableRowClick })] })] }), _jsxs(Accordion.Item, { eventKey: '2', className: 'vn-appsetting-accordian-item', children: [_jsx(Accordion.Header, { children: "Soort Werk" }), _jsxs(Accordion.Body, { children: [_jsx("div", { style: {
                                                display: 'flex',
                                                justifyContent: 'end',
                                                alignItems: 'center',
                                                marginRight: 'auto',
                                                marginLeft: '0rem',
                                                marginTop: '1rem',
                                                marginBottom: '1rem'
                                            } }), _jsx(WorkTypeTable, { onHandleRowClick: handleWorkTypeTableRowClick })] })] }), _jsxs(Accordion.Item, { eventKey: '3', className: 'vn-appsetting-accordian-item', children: [_jsx(Accordion.Header, { children: "TimeChimp Synchronisaties" }), _jsxs(Accordion.Body, { children: [_jsx("div", { style: {
                                                display: 'flex',
                                                justifyContent: 'end',
                                                alignItems: 'center',
                                                marginRight: 'auto',
                                                marginLeft: '0rem',
                                                marginTop: '1rem',
                                                marginBottom: '1rem'
                                            } }), _jsx(TimeChimpSync, {})] })] })] }) }), _jsx(ModalPopup, { title: 'Update Tijdwaarneming', content: _jsx(AddTimeKeepingForm, { onClose: () => onTimeKeepingcloseClicked(), updateCase: true }), onOpen: isUpdateAppSettingFormOpen, onClose: () => onTimeKeepingcloseClicked(), modalWidth: 'lg' }), _jsx(ModalPopup, { title: 'Nieuwe Categorie', content: _jsx(AddWorkorderCategoriesForm, { onClose: () => onWorkorderCategorycloseClicked(), updateCase: false }), onOpen: isAddWorkCategoryFormOpen, onClose: () => onWorkorderCategorycloseClicked(), modalWidth: 'lg' }), _jsx(ModalPopup, { title: 'Update Categorie', content: _jsx(AddWorkorderCategoriesForm, { onClose: () => onWorkorderCategorycloseClicked(), updateCase: true }), onOpen: isUpdateWorkCategoryFormOpen, onClose: () => onWorkorderCategorycloseClicked(), modalWidth: 'lg' }), _jsx(ModalPopup, { title: 'Update Soort Werk', content: _jsx(UpdateWorkTypeForm, { onClose: () => onWorkTypeCloseClicked(), workTypeId: currentWorkTypeId }), onOpen: isUpdateWorkTypeFormOpen, onClose: () => onWorkTypeCloseClicked(), modalWidth: 'lg' })] }));
};
export default AppSettingsTab;
